export default __webpack_public_path__ + "eee4730c501852a5041cfacbdef3e9b8.svg";